import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { addHydrateReducer } from "../../../utils/hydrateReducer";

/**
 * До недавнего времени состояние открыт/закрыт для нового попапа хранился в useState
 * данный slice предназначен для управления состоянием модального окна auth-popup
 * для возможности глобального управления состояние
 */
interface IHeaderAuthState {
  // только для нового auth-popup
  isAuthPopupVisible: boolean;
  /**
   * (ACQN) Обобщенные параметры аналитики (event.params) для AuthPopup
   * Обоснование: ранее мы прокидывали в пропсы, но AuthPopup может быть поднят экшеном редакса
   * и нам никак иначе не пробросить контекстные данные аналитики для попапа
   */
  analyticsData: Record<string, unknown>;
}

const initialState: IHeaderAuthState = {
  isAuthPopupVisible: false,
  analyticsData: {},
};

export const headerAuthSlice = createSlice({
  name: "global/header/auth",
  initialState,
  reducers: {
    setAuthPopupVisibility: (
      state: IHeaderAuthState,
      action: PayloadAction<IHeaderAuthState["isAuthPopupVisible"]>
    ) => {
      state.isAuthPopupVisible = action.payload;
    },

    setAnalyticsData: (
      state: IHeaderAuthState,
      action: PayloadAction<IHeaderAuthState["analyticsData"]>
    ) => {
      state.analyticsData = { ...state.analyticsData, ...action.payload };
    },
  },
  extraReducers: builder => {
    addHydrateReducer(builder, "global.header.auth");
  },
});

export const { setAuthPopupVisibility, setAnalyticsData } =
  headerAuthSlice.actions;

export default headerAuthSlice.reducer;
